import { NgModule } from '@angular/core';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/app/belender/page-layout/page-layout.module';
import { ExpirationDateComponent } from './expiration-date.component';
import { ExpirationDateRoutingModule } from './expiration-date-routing.module';
import { MaterialModule } from 'src/app/shared/modules/materia.module';
import { AssetUrlModule } from 'src/pipes/asset-url.module';


@NgModule({
  declarations: [ExpirationDateComponent],
  imports: [
    ExpirationDateRoutingModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule,
    AssetUrlModule
  ],
  providers: [
    CustomizationService
  ],
})
export class ExpirationDateModule { }
